export default __webpack_public_path__ + "13c17db889176bed9ddfc9ed8f05ac31.ttf";